import { requireActiveOrg } from '../lib/config'
import { FlightDeskAPI } from '../lib/api'

interface PromptOptions {
  type: string
}

export async function promptCommand(taskId: string, options: PromptOptions): Promise<void> {
  const { config, org } = requireActiveOrg()
  const api = FlightDeskAPI.fromConfig(config, org)
  const validTypes = ['review', 'test_plan', 'summary', 'handoff']

  if (!validTypes.includes(options.type)) {
    console.error(`Invalid prompt type: ${options.type}`)
    console.error(`Valid types: ${validTypes.join(', ')}`)
    process.exit(1)
  }

  try {
    const prompts = await api.getTaskPrompts(taskId)
    const prompt = prompts.find(p => p.type === options.type)

    if (!prompt) {
      console.error(`Prompt type "${options.type}" not found for this task`)
      process.exit(1)
    }

    if (!prompt.available) {
      console.error(`Prompt not available: ${prompt.reason || 'Unknown reason'}`)
      process.exit(1)
    }

    // Output the prompt content (ready for copy-paste)
    console.log(prompt.content)
  } catch (error) {
    console.error(`Error: ${error}`)
    process.exit(1)
  }
}
